import {remCalc} from '../../_utils'

export default {
    baseStyle: ({colorlessHeaders}: {colorlessHeaders: boolean}) => ({
        productCompareContainer: {
            flexDir: 'column',
            layerStyle: 'full-width',
            width: '100%',
            marginTop: {base: 'medium.base', md: 'medium.md'},
        },
        headerContainer: {
            justifyContent: 'center',
            marginBottom: {base: 'medium.base', lg: 'medium.md'},
        },
        headerText: {
            textStyle: 'head-small',
            color: 'text.default',
            fontWeight: 'medium',
        },
        gridCell: {
            border: 'small',
            borderColor: 'border.table',
            textStyle: 'body-small',
            fontWeight: 'normal',
            whiteSpace: 'normal',
            width: '100%',
            paddingTop: 'small.base',
            paddingBottom: 'small.base',
            paddingLeft: {
                base: remCalc(8),
                md: remCalc(30),
            },
            paddingRight: {
                base: remCalc(8),
                md: remCalc(30),
            },
            borderStyle: 'solid',
            color: 'text.default',
            alignContent: 'center',
        },
        gridHeading: {
            background: {
                base: colorlessHeaders ? '' : 'background.grey',
                lg: '',
            },
            textAlign: {base: 'center', lg: 'left'},
        },
        selectContainer: {
            justifyContent: 'flex-end',
            marginBottom: {base: 'small.base'},
        },
        icon: {
            width: remCalc(24),
            height: remCalc(24),
        },
        productsTypo: {
            textAlign: 'center',
            color: 'text.secondary',
            whiteSpace: 'normal',
        },
        productCompareTile: {
            width: {base: '50%', lg: '33.33%'},
            flexDir: 'column',
            maxW: remCalc(450),
            alignItems: 'center',
            color: 'text.default',
        },
        productCompareTileImage: {
            maxW: remCalc(214),
        },
        productNameLabel: {
            textStyle: 'head-xsmall',
            fontWeight: 'bold',
            marginTop: remCalc(14),
        },
        productIdLabel: {
            textStyle: 'body-small',
            fontWeight: 'normal',
            color: 'text.secondary',
            marginTop: remCalc(12),
            marginBottom: remCalc(14),
        },
        productPriceLabel: {
            textStyle: 'body-large',
            fontWeight: 'normal',
            color: 'text.default',
        },
        productRetailPriceLabel: {
            textStyle: 'body-xsmall',
            fontWeight: 'normal',
            color: 'text.secondary',
            marginTop: remCalc(12),
            marginBottom: remCalc(14),
        },
        productSpecsContainer: {
            width: '100%',
            gap: {base: 'xsmall.base', md: 'small.base', lg: 'small.lg'},
            marginBottom: remCalc(34),
            textAlign: 'center',
            justifyContent: {base: 'center', lg: 'space-evenly'},
        },
        specsButtonContainer: {
            my: {base: 'medium.base', md: 'medium.md'},
            justifyContent: 'center',
        },
        specsButtonText: {
            textStyle: 'body-medium',
            fontWeight: 'bold',
        },
        specsButton: {
            color: 'button.text.default',
        },
        gridLabel: {
            fontWeight: 'normal',
        },
    }),
}
